export default __webpack_public_path__ + "static/media/wecando.9c13a40a.wav";